import React from "react";

const Footer = () => {
  return (
    <footer className="footer footer-center p-10 text-base-content rounded">
      {" "}
      <p className="font-[Poppins] text-white opacity-70">
        Copyright © 2024 - Phillippe Louis Portfolio
      </p>
    </footer>
  );
};
export default Footer;
